module.exports = __webpack_public_path__ + "img/64.7385ca1c.svg";